import { createContext } from 'react';

import { Program } from '@totem/components/portfolio/buildings/details/optimize/types';

interface Context {
  buildingId: string;
  programs: Program[];
  loading: boolean;
  requestRefresh: () => void;
}

const defaultContext: Context = {
  buildingId: '',
  programs: [],
  loading: false,
  requestRefresh: () => {},
};

const OptimizeContext = createContext<Context>(defaultContext);

export default OptimizeContext;
